import { config } from "config";
import format from "date-fns/format";
import { change, reset } from "redux-form";
import { fields } from ".";
import MyForm from "components/templates/MyForm";
import { MODAL, modalActions } from "redux/slices/modal";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { assetManagementActions } from "redux/slices/assetManagement/assetManagementSlice";
import AssetManagementService from "services/assetManagement.service";

export default function AssetFilters() {
    const form = "AssetFiltersForm";
    const dispatch = useAppDispatch();
    const filters = useAppSelector((state) => state.assetManagement.filters);

    const onClickReset = () => {
        const default_page_size = config.PAGE_SIZE;
        dispatch(assetManagementActions.resetFilters());
        dispatch(reset(form));
        dispatch(change(form, "page_size", default_page_size));
        dispatch(assetManagementActions.setCurrentFilters({}));
    };

    const handleonClickExport = () => {
        dispatch(
            modalActions.openModal({
                width: "500px",
                type: MODAL.EXPORT_TABLE_OPTIONS,
                data: { table_data: [], file_name: "Assets" },
            })
        );
        AssetManagementService.getAssetListing({ ...filters, all: true });
    };

    const handleSubmit = (values: any) => {
        const default_page_size = config.PAGE_SIZE;
        let data: any = { page: 1, page_size: default_page_size };
        const {
            driver_id,
            category_id,
            subcategory_id,
            status,
            date,
            page_size
        } = values;

        if (driver_id?.value || driver_id) {
            data.driver_id = driver_id?.value || driver_id;
        }

        if (category_id) {
            if (Array.isArray(category_id)) {
                data.category_id = category_id.map((cat: any) => cat?.value || cat).filter(Boolean);
            } else {
                const catId = category_id?.value || category_id;
                if (catId) {
                    data.category_id = [catId];
                }
            }
        }

        if (subcategory_id) {
            if (Array.isArray(subcategory_id)) {
                data.subcategory_id = subcategory_id.map((sub: any) => sub?.value || sub).filter(Boolean);
            } else {
                const subId = subcategory_id?.value || subcategory_id;
                if (subId) {
                    data.subcategory_id = [subId];
                }
            }
        }

        if (status) {
            data.status = status.value || status;
        }

        if (page_size) {
            data.page_size = Number(page_size);
        }

        if (date && date.date[0] && date.date[1]) {
            data.end_date = format(new Date(date.date[1]), "yyyy-MM-dd");
            data.start_date = format(new Date(date.date[0]), "yyyy-MM-dd");
        }

        dispatch(assetManagementActions.setFilters(data));
        dispatch(assetManagementActions.setCurrentFilters(data));
    };

    return (
        <div className="filters">
            <MyForm
                form={form}
                myFields={fields}
                onSubmit={handleSubmit}
                onClickReset={onClickReset}
                onClickExport={handleonClickExport}
            />
        </div>
    );
}

